export function Event() {
    return { callbacks: [] };
}
export function on(e, callback) {
    e.callbacks.push(callback);
}
export function off(e, callback) {
    let index = e.callbacks.indexOf(callback);
    e.callbacks.splice(index, 1);
}
export function emit(e, value) {
    let list = e.callbacks.slice();
    for (let callback of list) {
        callback(value);
    }
}
